export default __webpack_public_path__ + "static/media/marker-icon-purple.197ae39e.png";